import $ from 'jquery';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create({
  onClick: Em.on('click', function () {
    this.storeCaretPosition();
  }),
  onInput: Em.on('input', function () {
    this.storeCaretPosition();
  }),
  onKeyUp: Em.on('keyUp', function () {
    this.storeCaretPosition();
  }),
  storeCaretPosition() {
    //TODO: GJ: coalesce calls to this
    if (this.get('canInsertAttributes')) {
      schedule('afterRender', this, this.setCaretPosition);
    }
  },
  setCaretPosition() {
    let $firstInput = $('input:first', this.element);
    if (this.element && $firstInput && $firstInput.length) {
      this.set('caretPosition', $firstInput[0].selectionStart);
      this.set('caretEndPosition', $firstInput[0].selectionEnd);
    }
  }
});